export const USER_TYPE = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  USER: "USER",
  GUEST: "GUEST",
};

export const FINANCE_CATEGORY_IDS = {
  CLIENT_INCOME: 1,
  EMPLOYEE_PAYMENT: 2,
  WORKER_PAYMENT: 3,
  VENDOR_PAYMENT: 4,
  SUBCONTRACTOR_PAYMENT: 5,
};

export const FCM_DEVICE_TOKEN_LS_KEY = "fcm_device_token";
